export default {
  create: {
    success: 'Indicateur financier créer avec succès',
    error: "Impossible de créer l'indicateur financier"
  },
  update: {
    success: "Modification de l'indicateur financier effectué avec succès",
    error: "Impossible mettre à jour l'indicateur financier"
  },
  delete: {
    success: 'Indicateur financier supprimé avec succès',
    error: "Impossible de supprimer l'indicateur financier"
  }
}
